import Head from 'next/head'
import React from 'react'
import getConfig from 'next/config'
import PolicyContent from '../../components/PolicyContent'
import dayjs from 'dayjs'

interface ContainerProps {
  privacyPolicyData: any
}

const Privacy: React.FC<ContainerProps> = ({ privacyPolicyData }) => {
  const lastModified = privacyPolicyData.modified
  const templateArr = JSON.parse(privacyPolicyData?.template)
  const headerTitle = templateArr.find(temp => temp.type === 'headertitle')

  return (
    <div id="main-content">
      <Head>
        <title>pOpshelf Privacy Policy</title>
        <meta name="description" content="pOpshelf privacy policy..." />
      </Head>
      <div className="privacy-policy" id="privacypolicy">
        <div className="privacy-policy__hero-ribbon">
          <h1>{headerTitle.value}</h1>
        </div>
        <div className="privacy-policy__row">
          <p className="privacy-policy__row-content--bold privacy-policy__date">{`LAST MODIFIED: ${dayjs(
            new Date(lastModified)
          ).format('MMM DD, YYYY')}`}</p>
        </div>
        <PolicyContent templateData={templateArr} />
      </div>
    </div>
  )
}

export const getServerSideProps = async () => {
  const { publicRuntimeConfig } = getConfig()

  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/user/${publicRuntimeConfig.ENV}/policypage?popkey=${publicRuntimeConfig.POP_KEY}&slug=privacy-policy`
  )
  const response = await res.json()
  return {
    props: {
      privacyPolicyData: response[0]
    }
  }
}

export default Privacy
